module.exports = __webpack_public_path__ + "img/vca.b0b88be8.png";